'use client';

import { fetchAssetMenu } from '@3fourteen/core';
import { useQuery } from '@tanstack/react-query';

export function usePbAssets() {
  return useQuery({
    queryKey: ['pb-asset-menu'],
    queryFn: async () => {
      const res = await fetchAssetMenu();

      // benchmark field exists at runtime but is missing from MenuAsset type in @3fourteen/core
      const benchmarks = res?.filter((d) => (d as any).benchmark === 1);
      const menuAssets = res?.filter((d) => (d as any).benchmark === 0);

      return {
        benchmarks,
        menuAssets,
      };
    },
  });
}
